var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      staticClass: "dt-gotop",
    },
    [_c("div", { staticClass: "dt-gotop-arrow", on: { click: _vm.go2top } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }